<template>
  <section class="app-container">
    <!-- <xp-topbar v-if="userInfo" :platform-name="$t(appName)" :user-info="userInfo" use-language></xp-topbar> -->
    <xp-topbar :platform-name="$t(appName)" use-language @language-changed="languageChanged"></xp-topbar>
    <xp-sidebar v-if="userInfo" :routes="routes" :collapse="isCollapse"></xp-sidebar>
    <xp-content v-if="userInfo"></xp-content>
  </section>
</template>

<script>
import XpTopbar from '@xpeng/topbar'
import XpSidebar from '@/vendor/xpeng/sidebar'
import XpContent from './content.vue'
// import Mobile from './mobile.vue'
import Language from './language.vue'
import loginUtil from '@/vendor/xpeng/login-util'
import Ajax from '@/ajax'
import Config from '@/config'

import { intl } from '@xpeng/i18n';

export default {
  components: {
    XpTopbar,
    XpSidebar,
    XpContent,
    // Mobile,
    Language
  },
  data () {
    return {
      appName: Config.APP_NAME,
      routes: [],
      showMobileBox: false,
      userInfo: null
    }
  },
  computed: {
    isCollapse (val) {
      return this.$store.state.sideBarCollapse
    }
  },
  mounted () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.9)'
    });
    Ajax({
      url: '/api/adminUser/current/status',
      method: 'get'
    })
      .then((res) => {
        if (res) {
          const { sysUser } = res
          this.routes = loginUtil.userMenusfilter(
            this.$router.options.routes,
            res
          )
          if (sysUser) {
            this.persistUserInfo(sysUser)
          }
          this.$store.commit('setUserRoot', res.root);
        } else {
          console.log('layout-status', res);
        }
      })
      .catch((err) => {
        console.log('layout-status', err);
      }).finally(() => {
        loading.close();
      })
  },
  methods: {
    persistUserInfo (userInfo) {
      this.userInfo = userInfo
      this.$store.commit('setUserInfo', userInfo)
    },
    languageChanged (language) {
      document.title = intl.$t(this.appName)
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100%;
}
</style>
